import { EventBus } from '../eventBus/EventBus';

export class StorageAdapter extends EventBus<{
  error: (key: string, operation: 'get' | 'set' | 'getJson' | 'setJson', error: unknown) => void;
}> {
  private readonly storage;
  private readonly storageAvailable: boolean;

  constructor(storage: Storage) {
    super();
    this.storage = storage;

    try {
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      this.storageAvailable = true;
    } catch (e) {
      this.storageAvailable = false;
    }
  }

  isAvailable(): boolean {
    return this.storageAvailable;
  }

  get(key: string): string | null {
    if (!this.storageAvailable) return null;
    return this.storage.getItem(key);
  }

  getJson<Payload = any>(key: string): Payload | null {
    const value = this.get(key);
    if (!value) return null;
    try {
      return JSON.parse(value) as Payload;
    } catch (error) {
      this.dispatchEvent('error', key, 'getJson', error);
      return null;
    }
  }

  set(key: string, value: string): void {
    if (!this.storageAvailable) return;
    this.storage.setItem(key, value);
  }

  setJson(key: string, value: Record<string, unknown>): void {
    try {
      const valueAsString = JSON.stringify(value);
      this.set(key, valueAsString);
    } catch (error) {
      this.dispatchEvent('error', key, 'setJson', error);
    }
  }

  remove(key: string): void {
    if (!this.storageAvailable) return;
    this.storage.removeItem(key);
  }
}
